import React from 'react';
import {
  Card,
  IconWrapper,
  Description,
  Title,
  IndicatorBox,
  IndicatorText,
} from './Card.info';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import NextImage from 'common/components/NextImage';
import { Box, Button } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const CardInfo = ({
  icon,
  icon2,
  icon3,
  title,
  description,
  type,
  indicator,
  plus,
}) => {

  return (
    <Card
      isFlex={type === 'Card 2 (Icon Text Same Line)'}
      type={type}
      data-aos="zoom-in"
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
        {icon?.url && (
          <IconWrapper type={type}>
            <NextImage field={icon} objectFit="cover" priority={true} />
          </IconWrapper>
        )}

         {icon2?.url && (
          <IconWrapper type={type}>
            <NextImage field={icon2} objectFit="cover" priority={true} />
          </IconWrapper>
        )} 

        {icon3?.url && Object.keys(icon).length > 0 && (
          <IconWrapper type={type}>
            <NextImage field={icon3} objectFit="cover" priority={true} />
          </IconWrapper>
        )}
      </Box>

      <div>
        <Title type={type}>{title}</Title>
        <Description type={type}>
          <PrismicRichText field={description} />
        </Description>
      </div>
      {indicator && (
        <IndicatorBox>
          <IndicatorText>{indicator}</IndicatorText>
        </IndicatorBox>
      )}
      {plus && (
        <Button
          component="a"
          href="/contact-us"
          endIcon={<ChevronRightIcon />}
          sx={{
            textTransform: 'none',
            color: '#1A1A1A', // texte sombre
            fontWeight: 500,
            fontSize: '14px',
            padding: '6px 12px',
            borderRadius: '25px',
            transition: 'color 0.3s ease',
            '&:hover': {
              backgroundColor: '#ff6e72',
            },
          }}
        >
          {plus}
        </Button>
        
      )}
      
    </Card>
  );
};

export default CardInfo;
